import { Box, styled, Typography, useTheme } from "@mui/material";
import React from "react";
import { blueTick } from "../../../assets";
import {
  BORROWED,
  CLAIMABLE,
  nftTempImage,
  ON_LEND,
  ON_RENT,
} from "../../../constants";
import { tokens } from "../../../theme";
import { conciseAddress } from "../../../utils/formatters";

const CardWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flex: 1,
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "10px 10px 10px 10px",
  backgroundColor: theme.palette.secondary.dark,
  // width: "263px",
  height: "300px",
  borderRadius: 14,
  boxShadow: "0px 15px 30px rgba(118, 118, 118, 0.2)",
  marginRight: "20px",
}));

const StatusStyle = (status) => {
  switch (status) {
    case ON_LEND:
      return {
        border: "#FFE28F",
        bgColor: "rgba(255, 226, 143, 0.1)",
      };
    case ON_RENT:
      return {
        border: "#FFE28F",
        bgColor: "rgba(255, 226, 143, 0.1)",
      };
    case BORROWED:
      return {
        border: "#FFE28F",
        bgColor: "rgba(255, 226, 143, 0.1)",
      };
    case CLAIMABLE:
      return {
        border: "#E430D1",
        bgColor: "rgba(228, 48, 209, 0.1)",
      };
    default:
      return {
        border: "#30E46D",
        bgColor: "rgba(48, 228, 109, 0.1)",
      };
  }
};

const StatusBox = styled(Box)(({ theme, status }) => ({
  width: "90px",
  height: "20px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  border: `1px solid ${StatusStyle(status).border}`,
  backgroundColor: `${StatusStyle(status).bgColor}`,
  borderRadius: "3px",
}));

export const NftPreviewCard = ({
  image,
  collectionName,
  tokenId,
  status,
  key,
  onClickPreview,
  address,
}) => {
  console.log("  collectionName,tokenId,status,", {
    collectionName,
    tokenId,
    status,
  });
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <CardWrapper key={key} onClick={() => onClickPreview()}>
      <img
        src={image || nftTempImage}
        alt={"nft"}
        onError={(e) => (e.currentTarget.src = nftTempImage)}
        style={{
          width: "80%",
          height: "199px",
          borderRadius: "11px",
          marginBottom: "15px",
          cursor: "pointer",
        }}
      />
      <Box
        display="flex"
        flexDirection="row"
        width="100%"
        marginBottom="5px"
        justifyContent="space-between"
      >
        <Box display="flex" flexDirection="column">
          <Box display="flex" flexDirection="row">
            <Typography
              variant="fs11"
              color={colors.black[500]}
              fontWeight={500}
              //   pl={1}
            >
              {collectionName?.length > 22
                ? `${collectionName.slice(0, 18)}...`
                : collectionName}
            </Typography>
            <img
              src={blueTick}
              style={{ marginLeft: "10px" }}
              alt={"blue tick"}
            />
          </Box>
          <Typography
            variant="fs14"
            color={colors.black[500]}
            fontWeight={500}
            // pl={1}
          >
            {`#${tokenId}`}
          </Typography>
        </Box>
        <StatusBox status={status}>
          <Typography
            variant="fs11"
            color={colors.black[500]}
            fontWeight={500}
            // pl={1}
          >
            {status}
          </Typography>
        </StatusBox>
      </Box>

      {address && (
        <Box
          display="flex"
          flexDirection="row"
          width={"100%"}
          justifyContent="space-between"
        >
          <Typography
            variant="fs14"
            width={"100%"}
            color={colors.black[500]}
            fontWeight={500}
            // pl={1}
          >
            Address
          </Typography>

          <Typography
            variant="fs14"
            width={"100%"}
            color={colors.black[500]}
            fontWeight={500}
            align="right"
            pl={1}
          >
            {conciseAddress(address)}
          </Typography>
        </Box>
      )}
    </CardWrapper>
  );
};
